import React from 'react';

export const WidgetCancelLink = (): JSX.Element => {
	return (
		<div className="ui-widget-link ui-widget-cancel-link">
			Select another form of payments
		</div>
	);
};
